var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40390",
    "data-name": "Group 40390",
    transform: "translate(-515 -221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_document-upload",
    "data-name": "vuesax/linear/document-upload",
    transform: "translate(151 33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-upload",
    transform: "translate(364 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15,6V9.75C15,13.5,13.5,15,9.75,15H5.25C1.5,15,0,13.5,0,9.75V5.25C0,1.5,1.5,0,5.25,0H9",
    transform: "translate(1.5 1.5)",
    fill: "#ecffed",
    stroke: "#61bf77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6,6H3C.75,6,0,5.25,0,3V0Z",
    transform: "translate(10.5 1.5)",
    fill: "none",
    stroke: "#61bf77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H18V18H0Z",
    fill: "none",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_46402",
    "data-name": "Path 46402",
    d: "M531.81,24.208l1.256,1.256,3.228-3.228",
    transform: "translate(-12.294 208.764)",
    fill: "none",
    stroke: "#61bf77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateChecked);
export default __webpack_public_path__ + "static/media/date-checked.adb8c76aa114ce6c611447b0df565677.svg";
export { ForwardRef as ReactComponent };